export const reloadPage = (): void => document.location.reload();
